import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5c795be4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "detail" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { class: "coupon_code" }, "クーポンコード"),
        /*#__PURE__*/ _createElementVNode("th", { class: "brand" }, "ブランド"),
        /*#__PURE__*/ _createElementVNode("th", { class: "coupon_name" }, "クーポン名"),
        /*#__PURE__*/ _createElementVNode("th", { class: "target_product" }, "対象商品"),
        /*#__PURE__*/ _createElementVNode("th", { class: "detailed_description" }, "詳細説明"),
        /*#__PURE__*/ _createElementVNode("th", { class: "discount" }, "割引"),
        /*#__PURE__*/ _createElementVNode("th", { class: "term_of_use" }, "利用条件"),
        /*#__PURE__*/ _createElementVNode("th", { class: "expiration_date" }, "有効期限"),
        /*#__PURE__*/ _createElementVNode("th", { class: "available_times" }, "利用可能回数"),
        /*#__PURE__*/ _createElementVNode("th", { class: "publisher" }, "発行者")
    ])
], -1));
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "coupon_code" };
const _hoisted_5 = { class: "brand" };
const _hoisted_6 = { class: "coupon_name" };
const _hoisted_7 = { class: "target_product" };
const _hoisted_8 = { class: "detailed_description" };
const _hoisted_9 = { class: "discount" };
const _hoisted_10 = { class: "term_of_use" };
const _hoisted_11 = { class: "expiration_date" };
const _hoisted_12 = { class: "available_times" };
const _hoisted_13 = { class: "publisher" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "modal-header" }, [
    /*#__PURE__*/ _createElementVNode("h3", { id: "modal-title" }, "詳細説明")
], -1));
const _hoisted_15 = { class: "modal-body" };
const _hoisted_16 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", null, [
            _hoisted_2,
            ($data.item)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
                    _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_4, _toDisplayString($data.item.coupon_code), 1),
                        _createElementVNode("td", _hoisted_5, _toDisplayString($data.item.brand), 1),
                        _createElementVNode("td", _hoisted_6, _toDisplayString($data.item.coupon_name), 1),
                        _createElementVNode("td", _hoisted_7, _toDisplayString($data.item.target_product), 1),
                        _createElementVNode("td", _hoisted_8, [
                            _createElementVNode("button", {
                                class: "detail-btn",
                                onClick: _cache[0] || (_cache[0] = ($event) => ($options.openModal($data.item.detailed_description))),
                                "aria-label": "詳細説明を開く"
                            }, [
                                _createVNode(_component_font_awesome_icon, {
                                    icon: "expand-alt",
                                    size: "lg",
                                    style: { "color": "#000" }
                                })
                            ])
                        ]),
                        _createElementVNode("td", _hoisted_9, _toDisplayString($data.item.discount) + _toDisplayString($data.item.discount_unit === 0 ? "円" : "%") + "引き ", 1),
                        _createElementVNode("td", _hoisted_10, _toDisplayString($data.item.term_of_use), 1),
                        _createElementVNode("td", _hoisted_11, _toDisplayString($options.formatDate($data.item.expiration_date)), 1),
                        _createElementVNode("td", _hoisted_12, _toDisplayString($data.item.available_times), 1),
                        _createElementVNode("td", _hoisted_13, _toDisplayString($data.item.publisher), 1)
                    ])
                ]))
                : _createCommentVNode("", true)
        ]),
        ($data.showModal)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "modal-overlay",
                onClick: _cache[2] || (_cache[2] =
                    //@ts-ignore
                    (...args) => ($options.closeModal && $options.closeModal(...args)))
            }, [
                _createElementVNode("div", {
                    class: "modal-dialog",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["stop"])),
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "modal-title"
                }, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", {
                            class: "modal-text",
                            innerHTML: $data.modalText
                        }, null, 8, _hoisted_16)
                    ])
                ])
            ]))
            : _createCommentVNode("", true)
    ]));
}
